import { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  fr: {
    nav: { piliers: "Nos Piliers", formules: "Formules", experiences: "Expériences", table: "La Table", reserver: "Réserver", devis: "Demander un devis", admin: "Admin", adminMobile: "Espace admin" },
    hero: {
      eyebrow: "Conciergerie haut de gamme — Paris & Bourgogne",
      l1: "Votre bien mérite",
      l2: "une signature",
      l2script: "d'exception",
      sub: "Rentabilité optimisée, expériences exclusives, tranquillité absolue. Nous orchestrons chaque détail de votre location courte durée.",
      cta1: "Confier mon bien",
      cta2: "Découvrir nos piliers",
    },
    marquee: ["Conciergerie haut de gamme", "Paris", "Bourgogne-Franche-Comté", "Rentabilité", "Sérénité", "Services sur mesure"],
    pillars: {
      eyebrow: "Notre manifeste",
      title: "Trois piliers, une promesse",
      cards: [
        { title: "Optimisation de la rentabilité", items: ["Tarification dynamique", "Mise en avant professionnelle des biens", "Ciblage d'une clientèle premium"] },
        { title: "Expériences exclusives", items: ["Chauffeur mis à disposition dès l'arrivée", "Accueil & livret d'accueil personnalisés", "Conciergerie 24/7", "Paniers repas aux produits du terroir", "Organisation de moments mémorables"] },
        { title: "Tranquillité absolue", items: ["Sélection rigoureuse des voyageurs", "Check-in orchestré", "Ménage de qualité hôtelière", "Petite maintenance", "Gestion des imprévus"] },
      ],
    },
    formules: {
      eyebrow: "Nos formules",
      title: "Une gestion à votre mesure",
      intro: "Tarifs transparents, sans frais cachés : 25% TTC des commissions perçues, hors frais de ménage et options voyageurs.",
      packs: [
        { tag: "La formule sérénité", name: "Gestion complète", items: ["Création & optimisation des annonces (Airbnb, Booking...)", "Gestion des réservations & communication voyageurs", "Accueil et départ des locataires", "Ménage professionnel & blanchisserie", "Gestion du linge de maison", "Maintenance légère & suivi du logement", "Assistance 7j/7 voyageurs & propriétaires"] },
        { tag: "L'essentiel maîtrisé", name: "Gestion partielle", items: ["Accueil et départ des voyageurs", "Ménage et gestion du linge", "Suivi du logement"] },
        { tag: "Selon vos besoins", name: "À la carte", items: ["Ménage seul — selon la typologie du logement", "Accueil / départ — à partir de 18 € TTC", "Blanchisserie — sur devis", "Maintenance / petits travaux — sur devis"] },
      ],
      conditionsTitle: "Conditions & tarification",
      conditions: ["Contrat de prestation signé avant le début de la gestion", "Facturation chaque fin de mois, à régler à réception", "Aucun engagement de durée — résiliation avec préavis de 30 jours"],
      forfaitTitle: "Forfait Propriétaire —",
      forfait: "si vous séjournez chez vous, commission à 0% ; seul un forfait fixe de remise en état / blanchisserie est dû à votre départ pour retrouver les standards hôteliers.",
      note: "* Les frais de ménage ainsi que les options payés par les voyageurs sont reversés à la conciergerie.",
      imgAlt: "Chambre préparée aux standards hôteliers",
    },
    exp: {
      eyebrow: "L'art de recevoir",
      title: "Chaque séjour devient un souvenir",
      p1: "Dès l'arrivée, un transfert privé accueille vos voyageurs. Un livret d'accueil personnalisé les guide, notre conciergerie répond 7j/7, et notre panier \"Bienvenue\" signature les attend : vin de pays, moutarde artisanale, biscuits de Montbozon ou macarons parisiens.",
      p2: "Paniers repas du terroir, baby-sitting & équipement bébé, espace de travail \"workation\", moments mémorables — demande en mariage, anniversaire — nous orchestrons chaque détail.",
      cta: "Créer une expérience",
      imgAlt: "Chauffeur privé, service d'exception",
    },
    videos: {
      eyebrow: "Immersion",
      title: "Entrez dans l'univers Shamar",
      cap1: "Visite d'un bien géré par Shamar — confort & standing",
      cap2: "Réception & buffet d'exception signés Shamar",
    },
    gallery: {
      eyebrow: "La table Shamar",
      title: "Le terroir, servi avec élégance",
      intro: "Petit-déjeuner, déjeuner ou dîner — nos paniers et buffets composés de produits du terroir accompagnent chaque séjour et chaque événement.",
      cap1: "Buffet raffiné — saumon fumé, navettes & charcuterie fine",
      cap2: "Pains artisanaux, fromages affinés & salades du terroir",
    },
    zones: {
      eyebrow: "Expériences signatures",
      title: "De Paris à la Bourgogne",
      parisTitle: "Paris — L'Éclat de la Capitale",
      parisText: "Shopping privé avec personal shopper, accès VIP — tables de restaurants et billets coupe-file — et Paris by Night : itinéraires nocturnes en voiture ou croisières privatisées sur la Seine.",
      bourgogneTitle: "Bourgogne-Franche-Comté — L'Immersion Terroir",
      bourgogneText: "Dégustations privées dans des caves séculaires, chef à domicile — truffe de Bourgogne, Comté affiné, volaille de Bresse — vélos électriques sur la Route des Grands Crus ou vol en montgolfière au-dessus des vignobles.",
      footerLine: "Propriétaires de résidences secondaires · Investisseurs · Location courte durée",
      imgAlt: "Intérieurs d'un bien géré par Shamar",
    },
    booking: {
      eyebrow: "Réservation en ligne",
      title: "Réservez votre prestation",
      intro: (a) => `Choisissez votre prestation, votre date et réglez en ligne — acompte de ${a} € ou totalité, en toute sécurité.`,
      step1: "1 — La prestation",
      step2: "2 — Date & créneau",
      step3: "3 — Coordonnées & paiement",
      services: { panier_terroir: "Panier terroir & traiteur", experience: "Expérience exclusive", menage: "Ménage de qualité hôtelière", gestion: "Rendez-vous gestion locative complète" },
      acompteLabel: "Acompte de réservation",
      totalLabel: "Totalité de la prestation",
      selectService: "— sélectionnez une prestation",
      nom: "Nom complet *", email: "Email *", tel: "Téléphone",
      payBtn: (a) => `Payer ${a} € et réserver`,
      payBtnEmpty: "Payer et réserver",
      redirect: "Redirection vers le paiement...",
      secured: "Paiement sécurisé par Stripe",
      slotTaken: "Ce créneau vient d'être réservé. Choisissez-en un autre.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      dateLocale: "fr",
    },
    quote: {
      eyebrow: "Parlons de votre bien",
      title: "Demandez votre devis sur mesure",
      intro: "Confiez-nous votre projet. Nous étudions votre bien et vous proposons un accompagnement personnalisé sous 24 heures.",
      nom: "Nom complet *", email: "Email *", tel: "Téléphone",
      typeBien: "Type de bien *", localisation: "Localisation *", service: "Service souhaité *",
      typeOptions: { "Appartement": "Appartement", "Maison": "Maison", "Résidence secondaire": "Résidence secondaire", "Bien d'investissement": "Bien d'investissement", "Autre": "Autre" },
      locOptions: { "Paris": "Paris", "Bourgogne-Franche-Comté": "Bourgogne-Franche-Comté", "Autre": "Autre" },
      serviceOptions: { "Gestion complète de location": "Gestion complète de location", "Optimisation de la rentabilité": "Optimisation de la rentabilité", "Expériences exclusives": "Expériences exclusives", "Traiteur & paniers terroir": "Traiteur & paniers terroir", "Événement sur mesure": "Événement sur mesure" },
      message: "Parlez-nous de votre projet...",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours...",
      successTitle: "Merci pour votre confiance",
      successText: "Votre demande a bien été transmise. Un membre de l'équipe Shamar vous recontactera sous 24 heures.",
      newRequest: "Nouvelle demande",
      toastOk: "Votre demande a bien été envoyée. Nous vous recontactons sous 24h.",
      toastErr: "Une erreur est survenue. Veuillez réessayer ou nous appeler au 07 66 23 01 45.",
    },
    footer: {
      desc: "Conciergerie haut de gamme — Rentabilité & sérénité. Paris & Bourgogne-Franche-Comté.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      links: { piliers: "Nos Piliers", experiences: "Expériences", table: "La Table", reserver: "Réserver", devis: "Devis" },
      zone: "Paris · Bourgogne-Franche-Comté",
      copyright: "Conciergerie haut de gamme. Tous droits réservés.",
      tagline: "Rentabilité & sérénité",
    },
    payment: {
      checking: "Vérification du paiement...",
      checkingSub: "Un instant, nous confirmons votre réservation.",
      thanks: "Merci !",
      confirmed: "Votre réservation est confirmée",
      service: "Prestation :", date: "Date :", amount: "Montant réglé :", deposit: "(acompte)",
      emailNote: "Un email de confirmation détaillé vous sera adressé. À très bientôt !",
      back: "Retour à l'accueil",
      errTitle: "Paiement non confirmé",
      errText: "Nous n'avons pas pu confirmer votre paiement. Contactez-nous au 07 66 23 01 45 si le montant a été débité.",
      cancelTitle: "Paiement annulé",
      cancelText: "Votre réservation n'a pas été finalisée. Vous pouvez réessayer à tout moment.",
      backBooking: "Revenir à la réservation",
    },
  },
  en: {
    nav: { piliers: "Our Pillars", formules: "Packages", experiences: "Experiences", table: "The Table", reserver: "Book Now", devis: "Request a quote", admin: "Admin", adminMobile: "Admin area" },
    hero: {
      eyebrow: "Luxury concierge — Paris & Burgundy",
      l1: "Your property deserves",
      l2: "an exceptional",
      l2script: "signature",
      sub: "Optimised returns, exclusive experiences, absolute peace of mind. We orchestrate every detail of your short-term rental.",
      cta1: "Entrust my property",
      cta2: "Discover our pillars",
    },
    marquee: ["Luxury concierge services", "Paris", "Burgundy-Franche-Comté", "Profitability", "Serenity", "Bespoke services"],
    pillars: {
      eyebrow: "Our manifesto",
      title: "Three pillars, one promise",
      cards: [
        { title: "Profitability optimisation", items: ["Dynamic pricing", "Professional property showcasing", "Premium guest targeting"] },
        { title: "Exclusive experiences", items: ["Private driver upon arrival", "Personalised welcome & guest book", "24/7 concierge", "Local terroir food baskets", "Memorable moments arranged"] },
        { title: "Absolute peace of mind", items: ["Rigorous guest screening", "Seamless check-in", "Hotel-grade housekeeping", "Light maintenance", "Handling the unexpected"] },
      ],
    },
    formules: {
      eyebrow: "Our packages",
      title: "Management tailored to you",
      intro: "Transparent pricing, no hidden fees: 25% incl. VAT of commissions earned, excluding cleaning fees and guest options.",
      packs: [
        { tag: "The serenity package", name: "Full management", items: ["Listing creation & optimisation (Airbnb, Booking...)", "Reservation management & guest communication", "Guest check-in and check-out", "Professional cleaning & laundry", "Household linen management", "Light maintenance & property monitoring", "7/7 support for guests & owners"] },
        { tag: "The essentials", name: "Partial management", items: ["Guest check-in and check-out", "Cleaning and linen management", "Property monitoring"] },
        { tag: "As you need", name: "À la carte", items: ["Cleaning only — based on property type", "Check-in / check-out — from €18 incl. VAT", "Laundry — on quotation", "Maintenance / small works — on quotation"] },
      ],
      conditionsTitle: "Terms & pricing",
      conditions: ["Service agreement signed before management begins", "Invoiced at each month's end, payable on receipt", "No long-term commitment — cancel with 30 days' notice"],
      forfaitTitle: "Owner's Package —",
      forfait: "when you stay in your own home, 0% commission; only a fixed restoration / laundry fee is due upon your departure to restore hotel standards.",
      note: "* Cleaning fees and options paid by guests are remitted to the concierge.",
      imgAlt: "Bedroom prepared to hotel standards",
    },
    exp: {
      eyebrow: "The art of hospitality",
      title: "Every stay becomes a memory",
      p1: "From the moment they arrive, a private transfer welcomes your guests. A personalised guest book guides them, our concierge answers 7/7, and our signature \"Welcome\" basket awaits: local wine, artisan mustard, Montbozon biscuits or Parisian macarons.",
      p2: "Terroir meal baskets, baby-sitting & baby equipment, \"workation\" workspace, memorable moments — wedding proposals, birthdays — we orchestrate every detail.",
      cta: "Create an experience",
      imgAlt: "Private chauffeur, exceptional service",
    },
    videos: {
      eyebrow: "Immersion",
      title: "Step into the Shamar world",
      cap1: "Tour of a property managed by Shamar — comfort & elegance",
      cap2: "Exceptional reception & buffet by Shamar",
    },
    gallery: {
      eyebrow: "The Shamar table",
      title: "Local flavours, served with elegance",
      intro: "Breakfast, lunch or dinner — our baskets and buffets of local produce accompany every stay and every event.",
      cap1: "Refined buffet — smoked salmon, mini rolls & fine charcuterie",
      cap2: "Artisan breads, matured cheeses & local salads",
    },
    zones: {
      eyebrow: "Signature experiences",
      title: "From Paris to Burgundy",
      parisTitle: "Paris — The Sparkle of the Capital",
      parisText: "Private shopping with a personal shopper, VIP access — restaurant tables and skip-the-line tickets — and Paris by Night: evening drives or private cruises on the Seine.",
      bourgogneTitle: "Burgundy-Franche-Comté — Terroir Immersion",
      bourgogneText: "Private tastings in centuries-old cellars, private chef at home — Burgundy truffle, aged Comté, Bresse poultry — e-bikes along the Route des Grands Crus or a hot-air balloon flight over the vineyards.",
      footerLine: "Second-home owners · Investors · Short-term rentals",
      imgAlt: "Interiors of a property managed by Shamar",
    },
    booking: {
      eyebrow: "Online booking",
      title: "Book your service",
      intro: (a) => `Choose your service and date, then pay securely online — €${a} deposit or full amount.`,
      step1: "1 — The service",
      step2: "2 — Date & time slot",
      step3: "3 — Details & payment",
      services: { panier_terroir: "Terroir basket & catering", experience: "Exclusive experience", menage: "Hotel-grade cleaning", gestion: "Full rental management appointment" },
      acompteLabel: "Booking deposit",
      totalLabel: "Full service amount",
      selectService: "— select a service",
      nom: "Full name *", email: "Email *", tel: "Phone",
      payBtn: (a) => `Pay €${a} and book`,
      payBtnEmpty: "Pay and book",
      redirect: "Redirecting to payment...",
      secured: "Secure payment by Stripe",
      slotTaken: "This slot has just been booked. Please choose another one.",
      error: "Something went wrong. Please try again.",
      dateLocale: "en",
    },
    quote: {
      eyebrow: "Let's talk about your property",
      title: "Request your tailored quote",
      intro: "Tell us about your project. We will review your property and offer a personalised plan within 24 hours.",
      nom: "Full name *", email: "Email *", tel: "Phone",
      typeBien: "Property type *", localisation: "Location *", service: "Desired service *",
      typeOptions: { "Appartement": "Apartment", "Maison": "House", "Résidence secondaire": "Second home", "Bien d'investissement": "Investment property", "Autre": "Other" },
      locOptions: { "Paris": "Paris", "Bourgogne-Franche-Comté": "Burgundy-Franche-Comté", "Autre": "Other" },
      serviceOptions: { "Gestion complète de location": "Full rental management", "Optimisation de la rentabilité": "Profitability optimisation", "Expériences exclusives": "Exclusive experiences", "Traiteur & paniers terroir": "Catering & terroir baskets", "Événement sur mesure": "Bespoke event" },
      message: "Tell us about your project...",
      submit: "Send my request",
      sending: "Sending...",
      successTitle: "Thank you for your trust",
      successText: "Your request has been received. A member of the Shamar team will contact you within 24 hours.",
      newRequest: "New request",
      toastOk: "Your request has been sent. We will get back to you within 24h.",
      toastErr: "Something went wrong. Please try again or call us at +33 7 66 23 01 45.",
    },
    footer: {
      desc: "Luxury concierge — Profitability & serenity. Paris & Burgundy-Franche-Comté.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      links: { piliers: "Our Pillars", experiences: "Experiences", table: "The Table", reserver: "Book", devis: "Quote" },
      zone: "Paris · Burgundy-Franche-Comté",
      copyright: "Luxury concierge services. All rights reserved.",
      tagline: "Profitability & serenity",
    },
    payment: {
      checking: "Verifying payment...",
      checkingSub: "One moment, we are confirming your booking.",
      thanks: "Thank you!",
      confirmed: "Your booking is confirmed",
      service: "Service:", date: "Date:", amount: "Amount paid:", deposit: "(deposit)",
      emailNote: "A detailed confirmation email will be sent to you. See you soon!",
      back: "Back to home",
      errTitle: "Payment not confirmed",
      errText: "We could not confirm your payment. Contact us at +33 7 66 23 01 45 if the amount was charged.",
      cancelTitle: "Payment cancelled",
      cancelText: "Your booking was not completed. You can try again at any time.",
      backBooking: "Back to booking",
    },
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("shamar_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("shamar_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
